var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { fab: "", large: "", color: "yellowLight" },
              on: {
                click: function($event) {
                  _vm.handleUpload()
                }
              }
            },
            [_c("v-icon", { attrs: { color: "primary" } }, [_vm._v("add")])],
            1
          ),
          _vm._v(" "),
          _c("input", {
            ref: "inputFile",
            staticClass: "input-file",
            staticStyle: { display: "none" },
            attrs: {
              type: "file",
              accept:
                "image/*,video/*,.xlsx,.xls,.doc, .docx,.ppt,.pptx,.txt,.pdf"
            },
            on: {
              change: function($event) {
                _vm.handleSelectFiles($event.target)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.vModel.length > 0
        ? _c(
            "v-flex",
            { staticClass: "upload__file-uploaded", attrs: { xs12: "" } },
            _vm._l(_vm.vModel, function(file, index) {
              return _c(
                "v-list",
                { key: file.id },
                [
                  _c("v-divider", {
                    staticClass: "upload__file-uploaded--divider"
                  }),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    { staticClass: "mt-3", attrs: { avatar: "" } },
                    [
                      _c(
                        "v-list-tile-avatar",
                        { attrs: { size: "50" } },
                        [
                          file.customType === "image"
                            ? _c("img", {
                                staticClass: "upload__file-uploaded--image",
                                attrs: { src: file.url, alt: "file.name" }
                              })
                            : _c("v-icon", [_vm._v(_vm._s(file.icon))])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", {
                            staticClass: "upload__file-uploaded--name",
                            domProps: { innerHTML: _vm._s(file.name) }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: { color: "#888" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  _vm.handleRemoveFile(
                                    file,
                                    index,
                                    file.customType
                                  )
                                }
                              }
                            },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dtFileError
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleHideError }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "600", scrollable: "" },
          model: {
            value: _vm.chooseFileDialog,
            callback: function($$v) {
              _vm.chooseFileDialog = $$v
            },
            expression: "chooseFileDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-flex",
                    {
                      staticClass:
                        "primary--text pa-0 mr-1 ml-1 modal-title--icon",
                      attrs: { "d-flex": "", xs1: "" }
                    },
                    [
                      _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                        _vm._v("attach_file")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ml-2 primary--text",
                      staticStyle: {
                        "font-family": "'Raleway', serif",
                        "font-size": "24px"
                      }
                    },
                    [_vm._v("Joindre un document")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleCancelSelect($event)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("icon-close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "fileForm",
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _vm.files.length
                                ? _c(
                                    "v-layout",
                                    {
                                      staticStyle: {
                                        border: "1px dashed #1B0B37"
                                      },
                                      attrs: {
                                        "align-start": "",
                                        "justify-start": "",
                                        row: "",
                                        "ma-3": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { shrink: "", "pa-2": "" } },
                                        [
                                          _vm.files[0].customType === "image"
                                            ? _c("v-img", {
                                                attrs: {
                                                  "aspect-ratio": "1",
                                                  width: "96",
                                                  src: _vm.files[0].url
                                                }
                                              })
                                            : _vm.files[0].customType ===
                                              "video"
                                            ? _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "64",
                                                    color: "primary"
                                                  }
                                                },
                                                [_vm._v("smart_display")]
                                              )
                                            : _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "64",
                                                    color: "primary"
                                                  }
                                                },
                                                [_vm._v("description")]
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { grow: "", "pa-2": "" } },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-truncate" },
                                            [
                                              _c("b", [_vm._v("Nom :")]),
                                              _vm._v(
                                                " " + _vm._s(_vm.files[0].name)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("b", [_vm._v("Taille :")]),
                                            _vm._v(
                                              " " + _vm._s(_vm.files[0].size)
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "base-control-label-vertical",
                                {
                                  attrs: {
                                    required: "",
                                    label: _vm.lblSetting.document_headers.ref
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      solo: "",
                                      rules: [
                                        function(v) {
                                          return (
                                            !!v ||
                                            _vm.$t(
                                              _vm.lblSetting.document_headers
                                                .ref
                                            ) + " est requise"
                                          )
                                        }
                                      ]
                                    },
                                    model: {
                                      value: _vm.reference,
                                      callback: function($$v) {
                                        _vm.reference = $$v
                                      },
                                      expression: "reference"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "base-control-label-vertical",
                                {
                                  attrs: {
                                    required: "",
                                    label: _vm.lblSetting.documentCategory
                                  }
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      items: _vm.coTypes1,
                                      "item-value": "id",
                                      "item-text": "name",
                                      required: true,
                                      rules: [
                                        function(v) {
                                          return (
                                            !!v ||
                                            _vm.$t(
                                              _vm.lblSetting.documentCategory
                                            ) + " est requise"
                                          )
                                        }
                                      ],
                                      solo: ""
                                    },
                                    on: { change: _vm.handleGetTypesLevel2 },
                                    model: {
                                      value: _vm.type,
                                      callback: function($$v) {
                                        _vm.type = $$v
                                      },
                                      expression: "type"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.coTypes2.length &&
                              _vm.type &&
                              _vm.mediaTypeLevel2Allowed
                                ? _c(
                                    "base-control-label-vertical",
                                    {
                                      attrs: {
                                        label:
                                          _vm.lblSetting.documentSubCategory
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        staticClass: "ml-1",
                                        attrs: {
                                          items: _vm.coTypes2,
                                          "item-value": "id",
                                          "item-text": "name",
                                          solo: ""
                                        },
                                        on: {
                                          change: _vm.handleGetAttributesLevel2
                                        },
                                        model: {
                                          value: _vm.typeLvl2,
                                          callback: function($$v) {
                                            _vm.typeLvl2 = $$v
                                          },
                                          expression: "typeLvl2"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.files.length && _vm.coAttributes.length > 0
                                ? _c(
                                    "div",
                                    _vm._l(_vm.coAttributes, function(
                                      attribute,
                                      indexAttr
                                    ) {
                                      return _c("base-attribute-manager", {
                                        key: attribute.id,
                                        staticClass: "mt-0",
                                        attrs: {
                                          attribute: attribute,
                                          label: attribute.name
                                        },
                                        model: {
                                          value:
                                            _vm.fkFileAttr[indexAttr].value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fkFileAttr[indexAttr],
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "fkFileAttr[indexAttr].value"
                                        }
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "greyDarker", flat: "" },
                      on: { click: _vm.handleCancelSelect }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c("base-modal-submit-btn", {
                    attrs: { title: "Confirmer", disabled: !_vm.valid },
                    on: { record: _vm.handleRecordFileToUpload }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76e230b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e230b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal-upload-buttons-new/template.html
// module id = null
// module chunks = 